export const feedbackCharm_ariaLabel = "lCa";
export default {feedbackCharm_ariaLabel};